import { render, staticRenderFns } from "./u-swiper.vue?vue&type=template&id=21723e18&scoped=true&"
import script from "./u-swiper.vue?vue&type=script&lang=js&"
export * from "./u-swiper.vue?vue&type=script&lang=js&"
import style0 from "./u-swiper.vue?vue&type=style&index=0&id=21723e18&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21723e18",
  null
  
)

export default component.exports